module.exports = __webpack_public_path__ + "static/media/sample_segmentation_template.4658efcf.csv";